import React, {Component} from "react";
import themeService from "../../services/themeService";
import './themeToggle.css';

interface ThemeToggleState {
    theme: 'light' | 'dark';
}

class ThemeToggle extends Component<{}, ThemeToggleState> {
    private unsubscribe?: () => void;

    constructor(props: {}) {
        super(props);
        this.state = {
            theme: themeService.getTheme(),
        };
        this.handleToggle = this.handleToggle.bind(this);
    }

    componentDidMount() {
        this.unsubscribe = themeService.subscribe((theme) => {
            this.setState({ theme });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    handleToggle() {
        const newTheme = this.state.theme === 'dark' ? 'light' : 'dark';
        themeService.setTheme(newTheme, true); // Persist to user
    }

    render() {
        return (
            <button
                className="ThemeToggle-Button"
                onClick={this.handleToggle}
                aria-label={`Switch to ${this.state.theme === 'dark' ? 'light' : 'dark'} theme`}
                title={`Switch to ${this.state.theme === 'dark' ? 'light' : 'dark'} theme`}
            >
                {this.state.theme === 'dark' ? '☀️' : '🌙'}
            </button>
        );
    }
}

export default ThemeToggle;

